import { Component, OnDestroy } from '@angular/core';
import { CookieAcceptanceService } from '../../service/cookie-acceptance.service';
import { Subscription } from 'rxjs';

@Component({
    selector: '.front-cookie-popup',
    templateUrl: './cookie-popup.component.html',
    styleUrl: './cookie-popup.component.scss'
})
export class CookiePopupComponent implements OnDestroy {
    public isActive: boolean = false;

    private cookieAcceptanceSubscription?: Subscription;

    public constructor(
        private readonly cookieAcceptanceService: CookieAcceptanceService
    ) {
        this.cookieAcceptanceSubscription = this.cookieAcceptanceService.isCookiePopupVisible.subscribe((isVisible: boolean) => {
            this.isActive = isVisible;
        });
    }

    public ngOnDestroy(): void {
        this.cookieAcceptanceSubscription?.unsubscribe();
    }

    public acceptAllCookies(): void {
        this.cookieAcceptanceService.setAllCookieSettings();
        this.cookieAcceptanceService.isCookiePopupVisible.next(false);
    }

    public customizeCookies(): void {
        this.cookieAcceptanceService.isCookiePopupVisible.next(false);
        this.cookieAcceptanceService.isCookieDetailsPopupVisible.next(true);
    }
}
